import isEmpty from 'lodash/isEmpty'

import { apiEndpoints } from './common'

import { get } from '../request'

const listAnalyticsDashboards = async () => {
  const response = await get(`${apiEndpoints.analytics}/dashboards/`)
  return response.data
}

const getAnalyticsDashboard = async (dashboardId) => {
  if (isEmpty(dashboardId)) {
    throw new Error('dashboard id is required')
  }
  const response = await get(
    `${apiEndpoints.analytics}/dashboards/${dashboardId}/`
  )
  return response.data
}

const getAnalyticsDashboardData = async (dashboardId, params = {}) => {
  if (isEmpty(dashboardId)) {
    throw new Error('dashboard id is required')
  }
  const clean = Object.fromEntries(
    Object.entries(params || {}).filter(([, v]) => v !== '' && v != null)
  )
  const response = await get(
    `${apiEndpoints.analytics}/dashboards/${dashboardId}/data/`,
    { params: clean }
  )
  return response.data
}

const getAnalyticsFilterOptions = async () => {
  const response = await get(`${apiEndpoints.analytics}/options/`)
  return response.data
}

export {
  listAnalyticsDashboards,
  getAnalyticsDashboard,
  getAnalyticsDashboardData,
  getAnalyticsFilterOptions
}
